import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const startResearch = (niche, region = "CA-ON") =>
  apiClient.post("/research/start", { niche, region }).then((r) => r.data);

export const getResearchJob = (jobId) =>
  apiClient.get(`/research/${jobId}`).then((r) => r.data);

export const getResearchHistory = () =>
  apiClient.get("/research/history/all").then((r) => r.data);

export const saveFavorite = (product, notes = "", tags = []) =>
  apiClient.post("/favorites", { product, notes, tags }).then((r) => r.data);

export const listFavorites = () =>
  apiClient.get("/favorites").then((r) => r.data);

export const updateFavorite = (favId, payload) =>
  apiClient.patch(`/favorites/${favId}`, payload).then((r) => r.data);

export const deleteFavorite = (favId) =>
  apiClient.delete(`/favorites/${favId}`).then((r) => r.data);

export const getSettings = () => apiClient.get("/settings").then((r) => r.data);
export const updateSettings = (payload) =>
  apiClient.put("/settings", payload).then((r) => r.data);
export const testCJConnection = () =>
  apiClient.post("/settings/cj/test").then((r) => r.data);
export const clearCJSettings = () =>
  apiClient.delete("/settings/cj").then((r) => r.data);

export const listSchedules = () =>
  apiClient.get("/schedules").then((r) => r.data);
export const createSchedule = (payload) =>
  apiClient.post("/schedules", payload).then((r) => r.data);
export const updateSchedule = (sid, payload) =>
  apiClient.patch(`/schedules/${sid}`, payload).then((r) => r.data);
export const deleteSchedule = (sid) =>
  apiClient.delete(`/schedules/${sid}`).then((r) => r.data);
export const runScheduleNow = (sid) =>
  apiClient.post(`/schedules/${sid}/run-now`).then((r) => r.data);

export const getDigestStatus = () =>
  apiClient.get("/digest/status").then((r) => r.data);
export const sendDigest = (jobId) =>
  apiClient.post(`/digest/send/${jobId}`).then((r) => r.data);

export const listRegions = () =>
  apiClient.get("/regions").then((r) => r.data);

export const getAnalyticsSummary = (params = {}) =>
  apiClient.get("/analytics/summary", { params }).then((r) => r.data);

export const getProductAnalytics = (productId, params = {}) =>
  apiClient.get(`/analytics/product/${productId}`, { params }).then((r) => r.data);

export const sendSalesDigest = (range = "7d") =>
  apiClient.post(`/digest/sales/send`, null, { params: { range } }).then((r) => r.data);

export const sendContactMessage = (payload) =>
  apiClient.post("/contact", payload).then((r) => r.data);

export const listOrders = (params = {}) =>
  apiClient.get("/orders", { params }).then((r) => r.data);

export const refundOrder = (sessionId, payload = {}) =>
  apiClient.post(`/orders/${sessionId}/refund`, payload).then((r) => r.data);

export const detectProductColors = (productId) =>
  apiClient.post(`/admin/products/${productId}/detect-colors`).then((r) => r.data);

export const getShippingRates = (payload) =>
  apiClient.post("/shipping/rates", payload).then((r) => r.data);

export const fulfillOrder = (sessionId) =>
  apiClient.post(`/admin/orders/${sessionId}/fulfill`).then((r) => r.data);

export const testCanadaPostConnection = () =>
  apiClient.post("/admin/shipping/test-connection").then((r) => r.data);

export const labelUrl = (sessionId) => `${API}/admin/orders/${sessionId}/label`;

export const updatePhotoColors = (productId, photo_colors) =>
  apiClient.patch(`/admin/products/${productId}/photo-colors`, { photo_colors }).then((r) => r.data);
